define('controllers/payment',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'debug',
    // services
    'services/i18n',
    'services/api',
    'services/session',
    // Contoller
    'src/controller/controller',
    // Views | Layout
    'views/app/payment',
], function(
    // Libs
    _, Backbone, Mustache, U, DEBUG,
    // services
    i18n,
    API,
    Session,
    // controller
    Controller,
    // Views | Layout
    VPaymentLayout
) {

    var PaymentCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '?*queryString': 'processPayment',
            'expired(/)': 'expiredGroup',
            'modifyMethod(/)': 'modifyMethod',
            'forceModifyMethod(/)': 'forceModifyMethod',
        },

        initialize: function(prefix, opt) {
            opt = opt || {};

            this.view = {};
        },

        getLayoutInstance: function() {
            return new VPaymentLayout(this.layoutOptions);
        },

        ////////////
        // routes //
        ////////////
        index: function() {
            this.redirect(Mustache.render(this.url.member, {
                groupId: 'default'
            }));
        },

        processPayment: function(queryString) {
            var params = this.parseQueryString(queryString);

            if (params.token) {
                this.layoutOptions = { view: "finishProcess" };
                this.layoutOptions.params = params;
                if (this.layout) {
                    this.layout.switchModal(this.layoutOptions, true);
                } else {
                    this.layout = this.getLayout();
                }
            } else {
                this.redirect('member');
            }
        },

        expiredGroup: function() {
            this.layoutOptions = { view: "expiredGroup" };

            if (this.layout) {
                this.layout.switchModal(this.layoutOptions, true);
            } else {
                this.layout = this.getLayout();
            }
        },

        forceModifyMethod: function() {
            this.modifyMethod(true);
        },

        modifyMethod: function(bForce) {
            if (!bForce)
                bForce = false;

            this.layoutOptions = { view: "modifyMethod", force: bForce };

            if (this.layout) {
                this.layout.switchModal(this.layoutOptions, true);
            } else {
                this.layout = this.getLayout();
            }
        },

        parseQueryString: function(queryString) {
            var params = {};
            if (queryString) {
                _.each(
                    _.map(decodeURI(queryString).split(/&/g), function(el, i) {
                        var aux = el.split('='), o = {};
                        if (aux.length >= 1) {
                            var val = "";
                            if (aux.length === 2)
                                val = aux[1];
                            o[aux[0]] = val;
                        }
                        return o;
                    }),
                    function(o) {
                        _.extend(params, o);
                    }
                );
            }
            return params;
        },
    });

    return PaymentCtrl;
});

